export default function formatBrandNames(brand: string): string {
  if (brand.toLocaleLowerCase() == 'mini' || brand.toLocaleLowerCase() == 'bmw') {
    return brand.toUpperCase()
  } else {
    return brand
  }
}
